import { createFileRoute } from "@tanstack/react-router"
import { ChangePasswordPage } from "@/pages/ChangePasswordPage"

export const Route = createFileRoute(
  "/_authenticated/_account/account-settings/security/change-password"
)({
  component: ChangePasswordPage,
})
